import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import ToastProvider from "./components/Tostify";
import configureStore from "./configureStore";
import history from "./utilize/history";

// Create redux store with history
const initialState = {};

const store = configureStore(initialState, history);

//google analytics

ReactDOM.render(
	<Provider store={store}>
		<ToastProvider>
			<App />
		</ToastProvider>
	</Provider>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

serviceWorker.unregister();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
